var React = require('react');

function NextArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.92188 1.5L3.92231 4.50044L0.921875 1.50087","stroke":"#262102","strokeWidth":"1.1","strokeLinecap":"round","strokeLinejoin":"round"}));
}

NextArrow.defaultProps = {"viewBox":"0 0 8 6","fill":"none"};

module.exports = NextArrow;

NextArrow.default = NextArrow;
